import Text from '../Text';
import Icon from '../Icon';
import TIcon from '../TIcon';

const Button = ({
    children = null,
    text = null,
    iconName = null,
    tIconName = null,
    overflow = "overflow-hidden",
    buttonColor = "bg-[#e4e4eb]",
    buttonClickClass = "active:bg-slate-500",
    classNames = "",
    itemPosition = "items-center justify-center",
    onClickAction = null,
    iconSize = 24,
    textType = "buttontext",
    borderStyle = "border rounded-md border-black",
    type = "button",
    textClasses = "",
    value = null,
    style = null,
    disabled = false }) => {
    return (
        <button
            onClick={onClickAction}
            className={`p-1 flex ${itemPosition} ${overflow} ${buttonColor} ${buttonClickClass} ${classNames} ${borderStyle}`}
            type={type}
            disabled={disabled}
            value={value}
            style={style}
        >
            {children}

            {/* Render TablerIcon if given */}
            {tIconName && <div className='h-full flex justify-center items-center '><TIcon name={tIconName} classNames='h-fit w-fit' size={iconSize} /></div>}

            {/* Render Text if given */}
            {text && <Text classNames={textClasses} type={textType}>{text}</Text>}

            {/* Render SVG if given */}
            {iconName && <div className={`h-full w-full flex ${itemPosition}`}><Icon iconName={iconName} classNames='h-full' /></div>}
        </button>
    )
}
export default Button